import { useEffect, useState } from "react";
import Container from "@/components/Container";
import Pager, { usePager } from "@/components/Pager";
import { api } from "@/lib/api";
import { toast } from "sonner";

const PRIORITIES = ["hot","high","medium","low","watching"];
const priorityColor = { hot:"text-ruby-light", high:"text-gold", medium:"text-ivory/80", low:"text-ivory/50", watching:"text-bronze" };

export default function Watchlist() {
  const [items, setItems] = useState([]);
  const [properties, setProperties] = useState([]);
  const [propertyId, setPropertyId] = useState("");
  const [priority, setPriority] = useState("medium");
  const [reason, setReason] = useState("");

  const load = () => api.get("/watchlist").then(r => setItems(r.data || []));
  useEffect(() => {
    load();
    api.get("/properties?limit=500").then(r => setProperties(r.data?.rows || []));
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!propertyId) return toast.error("Select a property");
    await api.post("/watchlist", { property_id: propertyId, priority, reason });
    toast.success("Added"); setPropertyId(""); setReason(""); load();
  };
  const del = async (id) => { await api.delete(`/watchlist/${id}`); load(); };
  const updatePriority = async (id, p) => { await api.put(`/watchlist/${id}`, { priority: p }); load(); };

  const pager = usePager(items);

  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Discovery</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Watchlist</h1>

      <form onSubmit={add} className="luxury-card p-5 mt-8 grid grid-cols-1 md:grid-cols-6 gap-3">
        <select className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" value={propertyId} onChange={e => setPropertyId(e.target.value)}>
          <option value="">Select property…</option>
          {properties.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
        </select>
        <select className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" value={priority} onChange={e => setPriority(e.target.value)}>
          {PRIORITIES.map(p => <option key={p}>{p}</option>)}
        </select>
        <input className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Reason / note" value={reason} onChange={e => setReason(e.target.value)} />
        <button className="btn-ruby justify-center">Add to Watchlist</button>
      </form>

      <div className="mt-6 luxury-card divide-y divide-charcoal-600/60">
        {items.length === 0 && <p className="p-8 text-center text-ivory/40 text-sm">Nothing on the watchlist.</p>}
        {pager.pageItems.map(w => (
          <div key={w.id} className="p-4 grid grid-cols-1 md:grid-cols-12 items-center gap-3" data-testid={`watch-${w.id}`}>
            <p className="md:col-span-4 text-ivory">{w.property?.title || w.property_id}</p>
            <p className="md:col-span-2 text-xs text-ivory/50">{w.property?.city || ""}</p>
            <select value={w.priority} onChange={e => updatePriority(w.id, e.target.value)}
              className={`md:col-span-2 bg-transparent border border-charcoal-600 px-2 py-1.5 text-xs uppercase tracking-[0.15em] ${priorityColor[w.priority] || "text-ivory"}`}>
              {PRIORITIES.map(p => <option key={p} className="bg-charcoal-800">{p}</option>)}
            </select>
            <p className="md:col-span-3 text-xs text-ivory/60 truncate">{w.reason}</p>
            <button onClick={() => del(w.id)} className="btn-outline !py-1 !px-2 text-xs">Remove</button>
          </div>
        ))}
      </div>
      <Pager {...pager} testid="watchlist-pager" />
    </Container>
  );
}
